"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteUserPage = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_toastify_1 = require("react-toastify");
require("./InviteUserPage.scss");
var InviteUserForm_1 = __importDefault(require("../components/InviteUserForm"));
var actions_1 = require("../state/actions");
var YellowButton_1 = require("@app/components/controls/YellowButton");
var Page_1 = require("@app/components/layout/Page");
var selectors_1 = require("@app/features/transfers/state/selectors");
var UsersApi = __importStar(require("@app/services/api/users"));
var initialState = {
    loading: false
};
var InviteUserPage = /** @class */ (function (_super) {
    __extends(InviteUserPage, _super);
    function InviteUserPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.errorToastId = 0;
        _this.handleSubmit = function (values) { return __awaiter(_this, void 0, void 0, function () {
            var error_1, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.setState({ loading: true });
                        return [4 /*yield*/, UsersApi.createUser({
                                email: values.email,
                                firstName: values.firstName,
                                lastName: values.lastName,
                                company: values.company,
                                title: values.title,
                                location: values.location
                            })];
                    case 1:
                        _a.sent();
                        this.setState({ success: true });
                        this.props.onLoadUserInteractions(true);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        errorMessage = '';
                        if (error_1.response && error_1.response.status === 409) {
                            errorMessage = 'An account already exists for this email address.\n\nIf they are experiencing log-in ' +
                                'issues, please have them reset their password or contact support at blast@hasbro.com.';
                        }
                        else {
                            errorMessage = 'Something went wrong while inviting the user. Please try again.';
                        }
                        this.toastError(errorMessage);
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState({ loading: false });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.resetForm = function () {
            _this.setState({ success: false });
        };
        _this.toastError = function (message) {
            if (react_toastify_1.toast.isActive(_this.errorToastId)) {
                react_toastify_1.toast.update(_this.errorToastId, {
                    autoClose: false,
                    className: 'invite-toast',
                    closeOnClick: false,
                    render: message
                });
            }
            else {
                _this.errorToastId = react_toastify_1.toast.error(message, {
                    autoClose: false,
                    className: 'invite-toast',
                    closeOnClick: false
                });
            }
        };
        return _this;
    }
    InviteUserPage.prototype.render = function () {
        var _a = this.state, loading = _a.loading, success = _a.success;
        return (react_1.default.createElement(Page_1.Page, { title: "Invite", isAsperaInitializing: this.props.asperaInitializing, isLoading: !this.props.asperaLoaded },
            react_1.default.createElement("div", { className: "columns" },
                react_1.default.createElement("div", { className: "column is-half is-offset-one-quarter" },
                    react_1.default.createElement("h1", { className: "title" }, "Invite User"),
                    react_1.default.createElement("h2", { className: "subtitle" }, "Invite an external user to collaborate using the Blast application"),
                    success ? (react_1.default.createElement("div", { className: "invite-success" },
                        react_1.default.createElement("p", null, "An invitation has been sent to the user with further instructions."),
                        react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", className: "button-large", onClick: this.resetForm }, "Invite Another User"))) : (react_1.default.createElement(InviteUserForm_1.default, { loading: loading, onSubmit: this.handleSubmit }))))));
    };
    return InviteUserPage;
}(react_1.Component));
exports.InviteUserPage = InviteUserPage;
var mapDispatchToProps = {
    onLoadUserInteractions: actions_1.loadUserInteractions
};
var mapStateToProps = function (store) {
    return {
        asperaInitializing: selectors_1.isAsperaInitializing(store),
        asperaLoaded: selectors_1.isAsperaLoaded(store)
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(InviteUserPage);
